import { getEvent, getEvents } from "$lib/utilities/content.js";

export const entries = async () => {
  const pages = await getEvents();
  return pages.map((event) => {
    return { slug: event.fields.slug.slice(1).slice(0, -1) };
  });
};
/**
 * @typedef {Object} Event
 * @property {string} title
 * @property {string} slug
 * @property {string} summary
 * @property {string} [description]
 * @property {string} [customDescription]
 * @property {string} [theme]
 * @property {"Exhibition or Exhibits"|"Campus Program"|"Special Event"|"Tour"|"Open Court"} type
 * @property {string} topics
 * @property {"All Ages"|"For Kids and Families"|"For Adults"|"For Youth"} audience
 * @property {("Fee Applies"|"Free"|"Registration Required")[]} addOns
 * @property {"none"|"daily"|"repeating"} recurrence
 * @property {string} start
 * @property {string} [end]
 * @property {boolean} ticketureEvent
 * @property {string} [registrationUrl]
 * @property {string} [ticketureID]
 * @property {Venue} [venue]
 * @property {boolean} waiverRequired
 * @property {boolean} dietaryRestrictionsRequired
 * @property {boolean} partnerEvent
 * @property {"none"|"daily"|"repeating"} partnershipDescription
 * @property {string} [subhead]
 * @property {EventImage} [image]
 * @property {Location} [specificLocation]
 * @property {Location} [rainLocation]
 * @property {ParentProgram} [parentProgram]
 */

/**
 * @typedef {Object} EventImage
 * @property {string} title
 * @property {Object} file
 * @property {string} file.url
 * @property {Object} file.details
 * @property {number} file.details.size
 * @property {Object} file.details.image
 * @property {number} file.details.image.width
 * @property {number} file.details.image.height
 * @property {string} file.fileName
 * @property {"image/png"|"image/jpeg"} file.contentType
 * @property {string} [description]
 */

/**
 * @typedef {Object} ParentProgram
 * @property {string} title
 * @property {string} obamaorgUrl
 * @property {string} theme
 * @property {string} programDescription
 * @property {boolean} hasOwnTicketure
 * @property {EventImage} [image]
 * @property {Date} [start]
 * @property {Date} [end]
 */

/**
 * @typedef {Object} Location
 * @property {string} locationName
 * @property {string} [directions]
 */

/**
 * @typedef {Object} Venue
 * @property {string} name
 * @property {string} address
 * @property {Object} latLong
 * @property {number} latLong.lon
 * @property {number} latLong.lat
 * @property {string} phone
 * @property {string} email
 * @property {string} description
 * @property {string} [hours]
 * @property {string} obamaorgUrl
 * @property {string} [addressLink]
 */

const stripFieldsFromEvent = (payload) => {
  const event = payload.fields;

  if (event) {
    if (event.image && event.image.fields) {
      event.image = event.image.fields;
    }

    if (event.parentProgram && event.parentProgram.fields) {
      event.parentProgram = event.parentProgram.fields;

      if (event.parentProgram.image && event.parentProgram.image.fields) {
        event.parentProgram.image = event.parentProgram.image.fields;
      }
    }

    if (event.venue && event.venue.fields) {
      event.venue = event.venue.fields;
    }

    if (event.specificLocation && event.specificLocation.fields) {
      event.specificLocation = event.specificLocation.fields;
    }

    if (event.rainLocation && event.rainLocation.fields) {
      event.rainLocation = event.rainLocation.fields;
    }
  }

  return event;
};

/**
 * @param {Object} params
 * @param {Object} params.params
 * @param {string} params.params.slug
 * @returns {{
 *   event: Event,
 *   recurringEvents: Event[],
 * }}
 */
export async function load(loadEvent) {
  const payload = await getEvent(loadEvent.params.slug);
  const event = stripFieldsFromEvent(payload);
  let { entry, ipls, epls } = loadEvent.data;
  return { event, entry, ipls, epls };
}
